// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Models
import { ScheduleImportResult } from '../models/Schedule';

// Services
import { ApiService, SettingService } from '../../common/modules/core/services';

@Injectable()
export class ScheduleService {
    private importScheduleUrl = '/students-schedule';
    private apiUrl = '';

    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    importSchedule(data: FormData): Observable<ScheduleImportResult> {
        const requestUrl = this.apiUrl + this.importScheduleUrl;

        return this.apiService.patch<ScheduleImportResult>(requestUrl, data);
    }
}


// WEBPACK FOOTER //
// ./src/holiday/services/ScheduleService.ts